var _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgMoveIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_269_4824)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M16.6663 15.8333L9.99967 11.25L3.33301 15.8333",
    stroke: "#FCFCFC",
    strokeWidth: 1.25,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M10 3.33301V11.2497",
    stroke: "#FCFCFC",
    strokeWidth: 1.25,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M9.16699 3.33333C9.16699 3.55435 9.25479 3.76631 9.41107 3.92259C9.56735 4.07887 9.77931 4.16667 10.0003 4.16667C10.2213 4.16667 10.4333 4.07887 10.5896 3.92259C10.7459 3.76631 10.8337 3.55435 10.8337 3.33333C10.8337 3.11232 10.7459 2.90036 10.5896 2.74408C10.4333 2.5878 10.2213 2.5 10.0003 2.5C9.77931 2.5 9.56735 2.5878 9.41107 2.74408C9.25479 2.90036 9.16699 3.11232 9.16699 3.33333Z",
    stroke: "#FCFCFC",
    strokeWidth: 1.25,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M2.5 15.8333C2.5 16.0543 2.5878 16.2663 2.74408 16.4226C2.90036 16.5789 3.11232 16.6667 3.33333 16.6667C3.55435 16.6667 3.76631 16.5789 3.92259 16.4226C4.07887 16.2663 4.16667 16.0543 4.16667 15.8333C4.16667 15.6123 4.07887 15.4004 3.92259 15.2441C3.76631 15.0878 3.55435 15 3.33333 15C3.11232 15 2.90036 15.0878 2.74408 15.2441C2.5878 15.4004 2.5 15.6123 2.5 15.8333Z",
    stroke: "#FCFCFC",
    strokeWidth: 1.25,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M15.833 15.8333C15.833 16.0543 15.9208 16.2663 16.0771 16.4226C16.2334 16.5789 16.4453 16.6667 16.6663 16.6667C16.8874 16.6667 17.0993 16.5789 17.2556 16.4226C17.4119 16.2663 17.4997 16.0543 17.4997 15.8333C17.4997 15.6123 17.4119 15.4004 17.2556 15.2441C17.0993 15.0878 16.8874 15 16.6663 15C16.4453 15 16.2334 15.0878 16.0771 15.2441C15.9208 15.4004 15.833 15.6123 15.833 15.8333Z",
    stroke: "#FCFCFC",
    strokeWidth: 1.25,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_269_4824"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 20,
    height: 20,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMoveIcon);
export default __webpack_public_path__ + "static/media/move-icon.c8c0d2b515936f7ef63d4f0294b4b41f.svg";
export { ForwardRef as ReactComponent };